import { useCallback } from 'react';
import { DraftList } from '../api/api';
import { useAxios } from '../context/AxiosContext';
import { useInfiniteQuery, useQueryClient } from 'react-query';
import { GroupSearchPayload } from './useGroupQuery';

export function useDraftQuery({ search }: Partial<GroupSearchPayload>) {
  const queryCache = useQueryClient();
  const { authAxios } = useAxios();

  const fetchDrafts = useCallback(
    async (term: string | undefined, nextPage): Promise<DraftList> => {
      const url: string = term ? `/draft/search/${term}` : `/draft`;
      const response = await authAxios.get<DraftList>(url, { params: { page: nextPage } });

      return response.data;
    },
    [authAxios]
  );

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage, status } = useInfiniteQuery(
    ['drafts', search],
    ({ pageParam }) => fetchDrafts(search, pageParam),
    {
      refetchOnWindowFocus: false,
      onError: () => {
        // Invalidate Query only if there is no successfull response
        queryCache.invalidateQueries(['drafts', search]);
      },
      getNextPageParam: (page) => page?.nextPage
    }
  );

  return {
    values: data?.pages,
    isDraftsFetching: isFetching,
    draftStatus: status,
    canFetchMore: hasNextPage,
    isFetchingMore: isFetchingNextPage,
    fetchMore: fetchNextPage
  };
}
